import { InputGroup } from 'react-bootstrap';
import Select, { Creatable } from 'react-select';
import React, { PureComponent } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getTextValue } from '../../helpers/utils';
import FormField from './FormField';

let id = 0;

class AutoComplete extends PureComponent {
    constructor(props) {
        super(props);
        this.handleBlur = this.handleBlur.bind(this);
        this.onChangeAction = this.onChangeAction.bind(this);
        this.ref = React.createRef();
    }

    handleBlur(evt) {
        let { inputValue } = this.selector;
        this.selector.createNewOption(inputValue);
        if (this.props.field.onBlur) {
            this.props.field.onBlur(evt);
        }
    }

    onChangeAction(selected) {
        let {
            field,
            onChange,
        } = this.props;

        if (!this.props.returnSelectedObject) {
            selected = getTextValue(selected);
        }

        if (field.onChange) {
            field.onChange(selected);
        }

        if (onChange) {
            onChange(selected);
        }

        return selected;
    }

    componentDidMount() {
        this.id = id++;
    }

    render() {
        let {
            required,
            isClearable = true,
            field,
            help,
            options = [],
            label,
            disabled,
            allowNew = false,
            loading,
            onFocus,
            afterAddon,
            beforeAddon,
            afterComponent,
            style,
            multiselect,
            valueRenderer,
            optionRenderer,
            wrapInputField,
            onInputKeyDown = undefined,
            shouldKeyDownEventCreateNewOption = undefined,
            hideDropDown = false,
            placeholder,
            onValueClick,
            showFormField = true,
            autosize = false,
        } = this.props;
        let selected = field.value;
        if (_.isString(field.value)) {
            selected = {label: field.value, value: field.value};
        }

        options = options.map((option) => {
            if (_.isString(option)) {
                return { label: option, value: option };
            }
            
            return option;
        });

        let className = undefined;
        if (hideDropDown) {
            className = 'hide-options';
        }

        let inputField = allowNew ? (
            <Creatable
                {...field}
                options={options}
                className={className}
                placeholder={placeholder}
                value={selected}
                onChange={this.onChangeAction}
                onCloseResetsInput={false}
                onBlurResetsInput={false}
                onInputKeyDown={onInputKeyDown}
                shouldKeyDownEventCreateNewOption={shouldKeyDownEventCreateNewOption}
                clearable={isClearable}
                multi={multiselect}
                disabled={disabled}
                autosize={autosize}
                id={field.name + '' + this.id}
                onFocus={onFocus}
                onBlur={this.handleBlur}
                ref={(s) => { this.selector = s; }}
                valueRenderer={valueRenderer}
                optionRenderer={optionRenderer}
                onValueClick={onValueClick}
                inputProps={{ autoComplete: 'random-string', autofill: 'off' }}
            />
            ) : (
            <Select
                {...field}
                options={options}
                className={className}
                placeholder={placeholder}
                value={selected}
                clearable={isClearable}
                autosize={autosize}
                onChange={this.onChangeAction}
                onInputKeyDown={onInputKeyDown}
                shouldKeyDownEventCreateNewOption={shouldKeyDownEventCreateNewOption}
                onSelectResetsInput={true}
                onCloseResetsInput={true}
                onBlurResetsInput={true}
                onFocus={onFocus}
                onBlur={field.onBlur}
                disabled={disabled}
                multi={multiselect}
                id={field.name + '' + this.id}
                valueRenderer={valueRenderer}
                optionRenderer={optionRenderer}
                onValueClick={onValueClick}
                inputProps={{ autoComplete: 'random-string', autofill: 'off' }}
            />
        );

        if (showFormField) {
            inputField = (
                <FormField
                    required={required}
                    field={field}
                    help={help}
                    loading={loading}
                    label={label}
                    style={style}
                    ref={this.ref}
                >{inputField}
                </FormField>
            );
        }

        if (wrapInputField) {
            inputField = wrapInputField(inputField, this.ref);
        }

        if (beforeAddon || afterAddon || afterComponent) {
            inputField = (
                <InputGroup>
                    {beforeAddon && (
                    <InputGroup.Addon>
                        {beforeAddon}
                    </InputGroup.Addon>)}
                    {inputField}
                    {afterAddon && (
                    <InputGroup.Addon>
                        {afterAddon}
                    </InputGroup.Addon>)}
                    {afterComponent}
                </InputGroup>
            );
        }

        return inputField;
    }
}

AutoComplete.propTypes = {
    field: PropTypes.object.isRequired,
    options: PropTypes.array,
    returnSelectedObject: PropTypes.bool,
    multiselect: PropTypes.bool,
}

export default AutoComplete;
